export default {
    language: 'nl-NL',
    navigation: 'Terug',
    home: {
        title: 'Verfcalculator',
        subtitle:
            'Graag helpen wij u bij het kiezen van het beste aangroei werende systeem voor uw boot en het berekenen van de benodigde hoeveelheid verf',
        findProduct: 'Zoek product',
        calculateVolume: 'Bereken het volume'
    },
    find: {
        questions: {
            type: '<strong>Type</strong>boot?',
            material: 'Boot<strong>materiaal</strong>?',
            sailFrequency: '<strong>Hoe vaak</strong>  gebruikt u uw boot?',
            paintLocation: '<strong>Waar</strong> lakt u uw boot?',
            waterType: 'In welk <strong>type water</strong> gebruik je je boot?'
        },
        answers: {
            help: 'Hulp nodig bij uw keuze voor een aangroei werend middel?',

            type: [
                {
                    label: 'Zeilboot',
                    icon: 'sailingBoat',
                    value: 'sailing'
                },
                {
                    label: 'Motorboot (langzaam)',
                    sublabel: 'lage snelheid (<20kn)',
                    icon: 'motorboatSlow',
                    value: 'motor-slow'
                },
                {
                    label: 'Motorboot (snel)',
                    sublabel: 'hoge snelheid (>20kn)',
                    icon: 'motorboatFast',
                    value: 'motor-fast'
                }
            ],
            material: [
                {
                    label: 'Glasvezel',
                    value: 'plastic'
                },
                {
                    label: 'Staal',
                    value: 'iron'
                },
                {
                    label: 'Hout',
                    value: 'wood'
                },
                {
                    label: 'Aluminum',
                    value: 'aluminium'
                }
            ],
            sailFrequency: [
                {
                    label: 'Zelden',
                    sublabel: '1 à 2 keer per maand of minder',
                    value: 'low'
                },
                {
                    label: 'Vaak',
                    sublabel: '1 à 2 keer per week',
                    value: 'medium'
                },
                {
                    label: 'Heel vaak',
                    sublabel: 'Bijna elke dag',
                    value: 'high'
                }
            ],
            paintLocation: [
                {
                    label: 'Kies land',
                    countries: [
                        { label: 'UK', value: 'en-GB' },
                        { label: 'US', value: 'en-US' },
                        { label: 'Canada', value: 'en-CA' },
                        { label: 'Denemarken', value: 'da-DK' },
                        { label: 'Spanje', value: 'es-ES' },
                        { label: 'Finland', value: 'fi-FI' },
                        { label: 'Duitsland', value: 'de-DE' },
                        { label: 'Griekenland', value: 'el-GR' },
                        { label: 'Kroatië', value: 'hr-HR' },
                        { label: 'Noorwegen', value: 'nb-NO' },
                        { label: 'Nederland', value: 'nl-NL' },
                        { label: 'Zweden - oostkust', value: 'sv-SE_e' },
                        { label: 'Zweden - westkust', value: 'sv-SE_w' },
                        { label: 'Zweden - meer', value: 'sv-SE_l' }
                    ]
                }
            ],
            waterType: [
                { label: 'Zee/Oceaan', value: 'sea/ocean' },
                { label: 'Rivier', value: 'rivers' },
                { label: 'Meer', value: 'lakes' }
            ]
        },
        result: {
            heading: 'Wij adviseren',
            selection: {
                title: 'Uw keuze',
                type: 'Type boot',
                waterType: 'Water type',
                material: 'Bootmateriaal',
                sailFrequency: 'Activiteit',
                country: 'Land'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Beste koop',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Beste koop',
                economicAlternative: 'Biocide-free Economic'
            },
            findOutMore: 'Meer vinden',
            whereToBuy: 'Verkrijgbaar bij',
            email: 'E-mailadres',
            send: 'Verzenden',
            feedback: {
                title: 'Was deze informatie nuttig?',
                yes: 'Ja',
                no: 'Nee',
                comment: 'Commentaar',
                placeholder: 'Commentaar'
            },
            recommendation: {
                title: 'Stuur uw aanbevelingen per E-mail'
            },
            calculateVolume: 'Bereken het volume'
        }
    },
    calculate: {
        letsCalculate: 'Berekenen',
        questions: {
            antifouling: 'Kiezen antifoulings',
            keelType: '<strong>Kiel</strong>type?',
            dimensions: 'Boot<strong>dimensie</strong>'
        },
        answers: {
            keelType: [
                {
                    label: 'Vinkiel',
                    icon: 'finKeel',
                    value: 'fin'
                },
                {
                    label: 'Volledige kiel',
                    icon: 'fullKeel',
                    value: 'full'
                }
            ],
            dimensionTitles: [
                {
                    title: 'Individuele afmetingen'
                },
                {
                    title: 'OF onderwateroppervlak in m2'
                }
            ],
            dimensions: [
                {
                    type: 'unit',
                    label: 'Eenheid',
                    values: [{ label: 'Meters', value: 'm' }, { label: 'Feet', value: 'f' }],
                    valuesUS: [{ label: 'Feet', value: 'f' }, { label: 'Meters', value: 'm' }]
                },
                {
                    type: 'waterline',
                    label: 'Lengte van de waterlijn'
                },
                {
                    type: 'beam',
                    label: 'Breedte'
                },
                {
                    type: 'draft',
                    label: 'Diepgang'
                },
                {
                    type: 'm2',
                    label: 'm2'
                }
            ]
        },
        result: {
            heading: 'Voorgestelde hoeveelheid',
            selection: {
                title: 'Uw keuze',
                antifouling: 'Antifouling',
                type: 'Type boot',
                material: 'Bootmateriaal',
                sailFrequency: 'Activiteit',
                country: 'Land',
                keelType: 'Kiel type',
                dimensions: 'Afmetingen boot'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Beste koop',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Beste koop',
                economicAlternative: 'Biocide-free Economic'
            },
            suggestedAmount: 'Voorgestelde hoeveelheid',
            suggestedAmountTwoCoats: 'Voorgestelde hoeveelheid (2 lagen)',
            oneCoat: '(1 laag)',
            fiveCoats: '(5 lagen)',
            primerAltTiecoatSilic: 'Vergeet niet om altijd een tiecoat te gebruiken!',
            primerAltSilicSealSilic:
                '<strong>CASE 2</strong><br/>Aanbrengen op de oude antifouling-laag in goede staat - gemakkelijke overgang naar Silic One systeem',
            primerAlLightSilic:
                '<strong>CASE 1</strong><br/>Verwijderen van oude antifouling-laag en aanbrengen van het volledige systeem & nieuwe boot zonder epoxy',

            primerAltTiecoat: 'Vergeet niet om altijd een tiecoat te gebruiken!',
            primerAltSilicSeal:
                '<strong>CASE 2</strong><br/>Aanbrengen van het volledige systeem & nieuwe boten',
            primerAlLight:
                '<strong>CASE 1</strong><br/>Aanbrengen op de oude antifouling-laag in goede staat',
            primer:
                'Wanneer de romp van de boot zwaar beschadigd is of wanneer u hem voor het eerst lakt? In dat geval heeft u nodig...',
            whereToBuy: 'Verkrijgbaar bij',
            email: 'E-mailadres',
            send: 'Verzenden',
            or: 'OF',
            feedback: {
                title: 'Was deze informatie nuttig?',
                yes: 'Ja',
                no: 'Nee',
                comment: 'Commentaar',
                placeholder: 'Commenataar'
            },
            recommendation: {
                title: 'Stuur uw aanbevelingen per E-mail'
            },
            calculateVolume: 'Bereken het volume'
        }
    },
    map: {
        country: 'Land',
        city: 'Stad',
        getDirections: 'Aanwijzingen opvragen',
        placeholder: 'Alle steden...'
    },
    footer: 'Hempel Yacht – Alles wat u moet weten over bootslak'
}
